export default {
    SUBMIT_SUCCESS_NANNY_FORM: {
        TITLE: 'Σας ευχαριστούμε για την αίτησή σας να γίνετε μέλος της ομάδας μας!',
        MESSAGE: 'Θα εξετάσουμε προσεκτικά την αίτησή σας και θα έρθουμε σε επαφή μαζί σας σύντομα, εάν φαίνεστε ότι ταιριάζει στην ομάδα μας! Λόγω του μεγάλου όγκου των αιτήσεων που λαμβάνουμε, μπορούμε να απαντήσουμε μόνο στους υποψηφίους που θα επιλέξουμε. Ευχαριστώ για την κατανόηση! Τώρα μπορείτε να κλείσετε με ασφάλεια αυτό το παράθυρο.'
    },
    SUBMIT_SUCCESS_REFERENCE_FORM: {
        TITLE: 'Σας ευχαριστούμε για τις πληροφορίες σας!',
        MESSAGE: 'Οι πληροφορίες αναφοράς που υποβάλατε είναι πολύ σημαντικές για εμάς. Μπορείτε να κλείσετε με ασφάλεια αυτό το παράθυρο τώρα.'
    },
    SUBMIT_SUCCESS_FAMILY_FORM: {
        INNER_HTML: `
        <h2>Σας ευχαριστούμε που υποβάλατε την εγγραφή σας!</h2>
        <h5>Θα επικοινωνήσουμε μαζί σας σύντομα! Τώρα μπορείτε να κλείσετε με ασφάλεια αυτό το παράθυρο.</h5>
        ΑΑΑΑΑΑΑΑΑΑΑ_`
    },
    PROFILE_COMPLETE_RESULT_DIALOG: {
        MESSAGE: 'Ευχαριστούμε που μας ενημερώσατε, θα επικοινωνήσουμε μαζί σας σύντομα!'
    },
    VIDEO_UPLOADE_RESULT_DIALOG: {
        INNER_HTML: `
        <h2>Το βίντεο ανέβηκε με επιτυχία!</h2>
        <h5>Σας ευχαριστούμε που υποβάλατε το εισαγωγικό βίντεο. Εάν δεν εμφανίζεται στην οθόνη, περιμένετε για λίγο και, στη συνέχεια, κάντε κλικ με μη αυτόματο τρόπο Ανανέωση (<i class="material-icons" style='position: absolute;'>ανανέωση</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp ;&nbsp;) κουμπί</h5>
        ΑΑΑΑΑΑΑΑΑΑΑ_`
    },
    UPDATE_SECTION_SUCCESS: {
        TITLE: "Η ενότητα αποθηκεύτηκε",
        MESSAGE: "Αποθηκευμένη ενότητα {0}!"
    },
    UPDATE_FAMILY_FORM_SUCCESS: {
        TITLE: "Η φόρμα οικογένειας ενημερώθηκε",
        MESSAGE: "Η φόρμα οικογένειας ενημερώθηκε με επιτυχία"
    },
    UPDATE_SECTION_REJECT: {
        TITLE: 'Ευχαριστώ',
        MESSAGE: "Θα εξετάσουμε τις πληροφορίες που έχετε υποβάλει και θα επικοινωνήσουμε μαζί σας εάν θέλουμε να προχωρήσουμε."
    },
    SUBMIT_REJECT_FORM: {
        TITLE: 'Ευχαριστώ',
        MESSAGE: "Θα εξετάσουμε τις πληροφορίες που έχετε υποβάλει και θα επικοινωνήσουμε μαζί σας εάν θέλουμε να προχωρήσουμε."
    },
    STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Η κατάσταση ενημερώθηκε.'
    },
    STATUS_UPDATED_RESULT_DIALOG_WITH_NO_EMAIL_TEMPLATE: {
        INNER_HTML: `<h2>Η κατάσταση ενημερώθηκε</h2>
        <h5>Θέλετε να ενεργοποιήσετε ένα μήνυμα ηλεκτρονικού ταχυδρομείου για μια αλλαγή σε αυτήν την κατάσταση; <button class="btn btn-secondary" id="add-template-button">Προσθήκη email</button></h5>`
    },
    STATUS_UPDATED_REFUND_RESULT_DIALOG: {
        TITLE: 'Η κατάσταση ενημερώθηκε. Επιστροφή χρημάτων στον πελάτη 1 πίστωση'
    },
    SUCCESSFULLY_BROADCAST_RESULT_DIALOG: {
        TITLE: 'Η εκπομπή εστάλη!'
    },
    NANNY_ASSIGNED_RESULT_DIALOG: {
        TITLE: 'Ο υποψήφιος εκχωρήθηκε!',
        MESSAGE: "Προχωρήστε στην ειδοποίηση {0}."
    },
    NANNY_ASSIGNED_WITHOUT_NOTIFICATION_RESULT_DIALOG: {
        TITLE: 'Ο υποψήφιος εκχωρήθηκε!',
    },
    NANNY_BULK_ASSIGNED_RESULT_DIALOG: {
        TITLE: "Ο υποψήφιος ανατέθηκε στις επιλεγμένες εργασίες",
        MESSAGE: "Προχωρήστε στην ειδοποίηση {0}."
    },
    NANNY_BULK_ASSIGNED_WITHOUT_NOTIFICATION_RESULT_DIALOG: {
        TITLE: "Ο υποψήφιος ανατέθηκε στις επιλεγμένες εργασίες",
    },
    BULK_ASSIGNED_RESULT_DIALOG: {
        TITLE: "Οι υποψήφιοι έχουν εκχωρηθεί",
    },
    JOB_UPDATED_RESULT_DIALOG: {
        TITLE: 'Η εργασία ενημερώθηκε!'
    },
    JOB_POSTED_RESULT_DIALOG: {
        TITLE: "Δημιουργήθηκε θέση εργασίας!"
    },
    JOB_ACCEPTANCE_TYPE_RESULT_DIALOG: {
        TITLE: "Ο τύπος αποδοχής ενημερώθηκε"
    },
    JOB_CHARGED_RESULT_DIALOG: {
        TITLE: "Χρέωση πελάτη και ενημερωμένη κατάσταση εργασίας!"
    },
    CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: "Ο πελάτης χρεώθηκε μέσω Stripe!"
    },
    CLIENT_CHARGED_STRIPE_RESULT_DIALOG: {
        TITLE: "Ο πελάτης χρεώθηκε μέσω Stripe!"
    },
    CLIENT_CHARGED_AUTHORIZE_NET_RESULT_DIALOG: {
        TITLE: "Ο πελάτης χρεώθηκε μέσω του Authorize.Net!"
    },
    BULK_JOBS_CHARGED_RESULT_DIALOG: {
        TITLE: "Χρέωση πελατών και ενημερωμένη κατάσταση θέσεων εργασίας!"
    },
    BULK_JOBS_CHARGED_WARNING_RESULT_DIALOG: {
        INNER_HTML: `<h2>Οι πελάτες χρεώθηκαν και η κατάσταση των θέσεων εργασίας ενημερώθηκε!</h2>
         <div>Απέτυχε η χρέωση των παρακάτω κρατήσεων</div>
         <ul>{0}</ul>`,
    },
    BULK_INVOICE_RESULT_DIALOG: {
        TITLE: "Πελάτες τιμολογήθηκαν!"
    },
    BULK_TRANSFER_RESULT_DIALOG: {
        TITLE: "Οι πελάτες χρεώθηκαν και οι υποψήφιοι πληρώθηκαν και η κατάσταση των θέσεων εργασίας ενημερώθηκε!"
    },
    BULK_TRANSFER_WARNING_RESULT_DIALOG: {
        INNER_HTML: `<h2>Χρέωση πελατών και πληρωμή των υποψηφίων και ενημερωμένη κατάσταση θέσεων εργασίας!</h2>
        {0}`,
    },
    MESSAGE_SENT_RESULT_DIALOG: {
        TITLE: 'Το μήνυμα εστάλη.'
    },
    MESSAGE_SCHEDULED_SEND_RESULT_DIALOG: {
        TITLE: "Το μήνυμα έχει προγραμματιστεί για αποστολή"
    },
    CHANGE_PASSWORD_RESULT_DIALOG: {
        TITLE: 'Ο κωδικός πρόσβασης επαναφέρθηκε με επιτυχία.'
    },
    SAVE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Η εικόνα προφίλ αποθηκεύτηκε με επιτυχία.'
    },
    DELETE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Η εικόνα προφίλ διαγράφηκε με επιτυχία.'
    },
    DOCUMENT_UPLOADED_RESULT_DIALOG: {
        TITLE: 'Έγγραφα μεταφορτώθηκαν.',
        MESSAGE: "Μπορεί να χρειαστούν μερικά δευτερόλεπτα για να επεξεργαστούν, αν δεν ενημερωθούν αμέσως, δοκιμάστε να κάνετε ανανέωση σε ένα λεπτό!"
    },
    DOCUMENT_SIGNED_RESULT_DIALOG: {
        TITLE: 'Το έγγραφό σας έχει υπογραφεί.'
    },
    DOCUMENT_SAVED_RESULT_DIALOG: {
        TITLE: 'Το έγγραφό σας έχει αποθηκευτεί.'
    },
    DOCUMENT_INFORMATION_UPDATED_RESULT_DIALOG: {
        TITLE: "Οι πρόσθετες πληροφορίες του εγγράφου {0} ενημερώθηκαν"
    },
    TEMPLATE_CREATED_RESULT_DIALOG: {
        TITLE: 'Το πρότυπο δημιουργήθηκε.'
    },
    TEMPLATE_UPDATED_RESULT_DIALOG: {
        TITLE: "Το πρότυπο ενημερώθηκε"
    },
    TEMPLATE_DELETED_RESULT_DIALOG: {
        TITLE: "Το πρότυπο διαγράφηκε"
    },
    TEMPLATE_DUPLICATED_RESULT_DIALOG: {
        TITLE: "Το πρότυπο είναι διπλό"
    },
    PASSWORD_RESET_RESULT_DIALOG: {
        TITLE: 'Επαναφορά κωδικού πρόσβασης',
        MESSAGE: 'Επαναφορά κωδικού πρόσβασης σε {0}'
    },
    PROFILE_BUILDER_UPDATED_RESULT_DIALOG: {
        TITLE: "Το πρόγραμμα δημιουργίας προφίλ ενημερώθηκε"
    },
    EMAIL_FOOTER_SAVED_RESULT_DIALOG: {
        TITLE: "Το υποσέλιδο ηλεκτρονικού ταχυδρομείου έχει αποθηκευτεί"
    },
    NOTIFICATION_SETTING_SAVED_RESULT_DIALOG: {
        TITLE: "Οι ρυθμίσεις ειδοποιήσεων αποθηκεύτηκαν"
    },
    ADDITIONAL_ADMIN_SETTINGS_SAVED_RESULT_DIALOG: {
        TITLE: "Πρόσθετες ρυθμίσεις διαχειριστή αποθηκεύτηκαν"
    },
    MANAGER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Ο διαχειριστής ενημερώθηκε.'
    },
    ADMIN_ADDED_RESULT_DIALOG: {
        TITLE: "Προστέθηκε ο διαχειριστής"
    },
    ADMIN_UPDATED_RESULT_DIALOG: {
        TITLE: "Ο διαχειριστής ενημερώθηκε"
    },
    ADMIN_DELETED_RESULT_DIALOG: {
        TITLE: "Ο διαχειριστής διαγράφηκε"
    },
    LOCATIONS_UPDATED_RESULT_DIALOG: {
        TITLE: "Οι τοποθεσίες ενημερώθηκαν"
    },
    BULK_DATA_UPDATED_RESULT_DIALOG: {
        TITLE: "{0} ενημερώθηκε"
    },
    BULK_DATA_ADDED_RESULT_DIALOG: {
        TITLE: "{0} Προστέθηκε"
    },
    LANGUAGE_UPDATED_RESULT_DIALOG: {
        TITLE: "Η γλώσσα ενημερώθηκε"
    },
    JOB_BROADCAST_SENT_RESULT_DIALOG: {
        TITLE: 'Η εκπομπή εστάλη σε {0} υποψηφίους!'
    },
    JOB_VIEWS_RESULT_DIALOG: {
        TITLE: "Προβολές εργασίας",
        MESSAGE: "Αριθμός προβολών: {0}"
    },
    BLAST_OFF_RESULT_DIALOG: {
        TITLE: "Εκρηκτική έκρηξη!",
        MESSAGE: "Τα email σας είναι καθ' οδόν! Μπορεί να χρειαστούν μερικά λεπτά, ανάλογα με τον αριθμό που αποστέλλονται. Θα εμφανιστούν στο γενικό αρχείο καταγραφής email και στα αρχεία καταγραφής email του μεμονωμένου χρήστη κατά την αποστολή τους."
    },
    NOTE_SAVED_RESULT_DIALOG: {
        TITLE: "Η σημείωση αποθηκεύτηκε!"
    },
    SAVE_AND_ADD_NEW_OBJECT: {
        TITLE: '{0} αποθηκεύτηκαν, προσθέστε άλλο ένα!',
        CLOSE_LABEL: "OK"
    },
    APPLICATION_STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Ευχαριστούμε που μας ενημερώσατε!'
    },
    JOB_ACCEPTED_RESULT_DIALOG: {
        TITLE: "Συγχαρητήρια, αποδεχτήκατε αυτήν τη δουλειά!",
        MESSAGE: 'Όλες οι λεπτομέρειες θα εμφανιστούν στον πίνακα ελέγχου σας στην ενότητα "Οι δουλειές μου".'
    },
    UPDATE_VISIBILITY_SCOPE_RESULT_DIALOG: {
        TITLE: "Το εύρος ορατότητας του {0} ενημερώθηκε σε {1}"
    },
    CHECK_FORM_UPDATED: {
        TITLE: "Η φόρμα επιταγής {0} ενημερώθηκε"
    },
    SAVED_CHANGES_RESULT_DIALOG: {
        TITLE: 'Οι αλλαγές αποθηκεύτηκαν!'
    },
    PRICE_CREATED_RESULT_DIALOG: {
        TITLE: "Η τιμή δημιουργήθηκε"
    },
    PRICE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Η τιμή ενημερώθηκε.'
    },
    PRICE_DELETED_RESULT_DIALOG: {
        TITLE: 'Η τιμή διαγράφηκε.'
    },
    BULK_RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: "Δημιουργήθηκαν σύνδεσμοι υποψηφίων για πελάτες!"
    },
    RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: "Δημιουργήθηκε σύνδεσμος υποψήφιος προς πελάτη!"
    },
    RELATIONSHIP_UPDATED_RESULT_DIALOG: {
        TITLE: "Ο σύνδεσμος Υποψήφιος προς Πελάτη ενημερώθηκε!"
    },
    OFFER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Η προσφορά ενημερώθηκε!'
    },
    REVIEW_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Σας ευχαριστούμε που γράψατε μια κριτική!'
    },
    MARKED_FAVORITE_RESULT_DIALOG: {
        TITLE: 'Επισημάνθηκε ως αγαπημένο!',
        MESSAGE: "Θα κάνουμε το καλύτερο δυνατό για να σας ταιριάξουμε μαζί τους στο μέλλον."
    },
    MARKED_DONT_WANT_RESULT_DIALOG: {
        TITLE: 'Ευχαριστούμε που μας ενημερώσατε.',
        MESSAGE: "Θα κάνουμε το καλύτερο δυνατό για να σας συνδέσουμε με άλλους στο μέλλον"
    },
    PAYMENT_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Σας ευχαριστούμε που υποβάλατε τα στοιχεία πληρωμής σας!"
    },
    PACKAGE_SELECTED_RESULT_DIALOG: {
        TITLE: 'Το πακέτο σας επιλέχθηκε, ευχαριστώ!',
        MESSAGE: "Η αναζήτησή μας βρίσκεται σε εξέλιξη, θα επικοινωνήσουμε σύντομα!"
    },
    EVALUATION_CREATED_RESULT_DIALOG: {
        TITLE: "Η αξιολόγηση δημιουργήθηκε."
    },
    EVALUATION_UPDATED_RESULT_DIALOG: {
        TITLE: "Η αξιολόγηση ενημερώθηκε."
    },
    EVALUATION_DELETED_RESULT_DIALOG: {
        TITLE: "Η αξιολόγηση διαγράφηκε."
    },
    QUESTION_CREATED_RESULT_DIALOG: {
        TITLE: "Η ερώτηση δημιουργήθηκε."
    },
    BLOCKTEXT_CREATED_RESULT_DIALOG: {
        TITLE: "Δημιουργήθηκε μπλοκ κειμένου"
    },
    QUESTION_UPDATED_RESULT_DIALOG: {
        TITLE: "Η ερώτηση ενημερώθηκε."
    },
    BLOCKTEXT_UPDATED_RESULT_DIALOG: {
        TITLE: "Το μπλοκ κειμένου ενημερώθηκε"
    },
    QUESTION_DELETED_RESULT_DIALOG: {
        TITLE: "Η ερώτηση διαγράφηκε."
    },
    BLOCKTEXT_DELETED_RESULT_DIALOG: {
        TITLE: "Το μπλοκ κειμένου διαγράφηκε"
    },
    EVALUATION_ADDED_RESULT_DIALOG: {
        TITLE: "Η αξιολόγηση προστέθηκε!"
    },
    EVALUATION_COMPLETED_RESULT_DIALOG: {
        TITLE: "{0} ολοκληρώθηκε, ευχαριστώ!",
        CLOSE_LABEL: "Τέλος"
    },
    TIME_OFF_REQUEST_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Το αίτημά σας για άδεια έχει υποβληθεί, θα το εξετάσουμε και θα επιβεβαιώσουμε όταν εγκριθεί!",
        CLOSE_LABEL: "Τέλος"
    },
    AVAILABILITY_NOTES_UPDATED_RESULT_DIALOG: {
        TITLE: "Οι σημειώσεις ενημερώθηκαν!",
        CLOSE_LABEL: "Συνέχεια"
    },
    BUFFER_TIME_UPDATED_RESULT_DIALOG: {
        TITLE: "Η ώρα buffer ενημερώθηκε!",
    },
    MAX_BOOKING_NUMBER_UPDATED_RESULT_DIALOG: {
        TITLE: "Ενημερώθηκε ο μέγιστος αριθμός κρατήσεων ανά ημέρα!",
    },
    SCHEDULE_UPDATED_RESULT_DIALOG: {
        TITLE: "Το χρονοδιάγραμμα ενημερώθηκε."
    },
    DOCUMENT_SEND_TO_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Το έγγραφο αποστέλλεται στον υποψήφιο"
    },
    DOCUMENT_MARK_AS_DRAFT_RESULT_DIALOG: {
        TITLE: "Το έγγραφο έχει επισημανθεί ως πρόχειρο"
    },
    DOCUMENT_PUBLISH_RESULT_DIALOG: {
        TITLE: "Το έγγραφο δημοσιεύτηκε"
    },
    DOCUMENT_UPDATED_RESULT_DIALOG: {
        TITLE: "Το έγγραφο ενημερώθηκε"
    },
    BOOKING_ON_BLOCKED_DATES_RESULT_DIALOG: {
        TITLE: "Ζητούμε συγγνώμη, έχουμε κρατηθεί για αυτήν την ημερομηνία! Θα σας προσθέσουμε στη λίστα ακύρωσης και θα σας ενημερώσουμε για τυχόν αλλαγές το συντομότερο δυνατό.",
        CLOSE_LABEL: "Συνέχεια"
    },
    CHECKLIST_SAVED_RESULT_DIALOG: {
        TITLE: "Η λίστα ελέγχου έχει αποθηκευτεί"
    },
    FEEDBACK_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Ευχαριστούμε, θα επικοινωνήσουμε σύντομα."
    },
    FEEDBACK_SUBMITTED_SUCCESS_RESULT_DIALOG: {
        TITLE: "Ευχαριστούμε για την υποβολή των σχολίων"
    },
    USER_ALERT_BLOCKED_POPUP_DIALOG: {
        TITLE: "Εάν δεν έχει ανοίξει ένα νέο παράθυρο, ελέγξτε εάν τα αναδυόμενα παράθυρα έχουν αποκλειστεί",
        CLOSE_LABEL: "Ακύρωση"
    },
    CLOCK_OUT_SUCCESS_RESULT_DIALOG: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Εάν υπήρχαν προβλήματα με την εγγραφή της ώρας ή οτιδήποτε άλλο, ενημερώστε μας.",
        CLOSE_LABEL: "Τέλος"
    },
    CLOCK_OUT_TRANSFER_SUCCESS_RESULT_DIALOG: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Θα πληρωθείτε απευθείας μέσω Stripe. Εάν υπήρχαν προβλήματα με την καταγραφή των ωρών ή οτιδήποτε άλλο, ενημερώστε μας.",
        CLOSE_LABEL: "Τέλος"
    },
    CLOCK_IN_SUCCESS_RESULT_DIALOG: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Μην ξεχάσετε να παρακολουθήσετε όταν τελειώσετε!",
        CLOSE_LABEL: "Τέλος"
    },
    SCHEDULE_RELEASED_RESULT_DIALOG: {
        TITLE: "Το πρόγραμμα κυκλοφόρησε!"
    },
    EVENT_BOOKED_RESULT_DIALOG: {
        TITLE: "Η εκδήλωση έγινε κράτηση!"
    },
    DOCUMENT_ADDED_RESULT_DIALOG: {
        TITLE: "Το έγγραφο προστέθηκε!"
    },
    MAILCHIMP_ADDED_RESULT_DIALOG: {
        TITLE: "Έγινε επιτυχής εγγραφή στη λίστα Mailchimp!"
    },
    TENTATIVE_ASSIGN_RESULT_DIALOG: {
        TITLE: "Η νταντά ανατέθηκε προσωρινά.",
    },
    TENTATIVE_ASSIGN_HAS_BIG_RED_BTN_RESULT_DIALOG: {
        TITLE: "Η νταντά ανατέθηκε προσωρινά.",
        MESSAGE: "Κανείς δεν έχει ειδοποιηθεί, θα ενημερωθεί όταν πατήσετε το μεγάλο κόκκινο κουμπί"
    },
    SECTION_PUBLIC_FORM_SUBMITTED: {
        TITLE: "{0} υποβλήθηκαν πληροφορίες",
        MESSAGE: "Σας ευχαριστούμε που υποβάλατε {0} πληροφορίες. Κλείστε το παράθυρο ή υποβάλετε ένα άλλο {1}"
    },
    USER_SECTION_PUBLIC_FORM_SUBMITTED: {
        TITLE: "{0} υποβλήθηκαν πληροφορίες",
        MESSAGE: "Σας ευχαριστούμε που υποβάλατε {0} πληροφορίες. Κλείστε το παράθυρο"
    },
    CANDIDATE_SELECTED_RESULT_DIALOG: {
        TITLE: "Σας ευχαριστούμε που επιλέξατε τον υποψήφιο"
    },
    CLOCK_IN_OUT_APPROVED_RESULT_DIALOG: {
        TITLE: "Οι ώρες εισόδου και ρολογιού έχουν εγκριθεί"
    },
    CLOCK_IN_OUT_DISAPPROVED_RESULT_DIALOG: {
        TITLE: "Οι ώρες εισόδου και ρολογιού απορρίφθηκαν"
    },
    PACKAGE_CREDIT_SELECTED_RESULT_DIALOG: {
        TITLE: '{0} Προστέθηκαν πιστώσεις, ευχαριστώ!',
    },
    MONTHLY_PACKAGE_CREDIT_SELECTED_RESULT_DIALOG: {
        TITLE: "{0} προστέθηκαν μηνιαίες πιστώσεις, ευχαριστούμε!",
    },
    STRIPE_SUBSCRIPTION_SELECTED_RESULT_DIALOG: {
        TITLE: "Η συνδρομή ξεκίνησε, σας ευχαριστώ!"
    },
    UNASSIGN_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Ο υποψήφιος καταργήθηκε"
    },
    SAVED_ADVANCE_SEARCH_RESULT_DIALOG: {
        TITLE: "Αποθηκευμένη εκ των προτέρων αναζήτηση"
    },
    BOOKING_ADDED_RESULT_DIALOG: {
        TITLE: "Η κράτηση προστέθηκε"
    },
    JOB_TIP_ADDED_RESULT_DIALOG: {
        TITLE: "Η συμβουλή προστέθηκε"
    },
    BULK_COPY_SUGGESTED_CHARGE_RESULT_DIALOG: {
        TITLE: "Αντιγράφηκε η προτεινόμενη χρέωση στη συνολική χρέωση πελάτη"
    },
    CANDIDATES_NO_LONGER_AVAILABLES: {
        TITLE: "Ο επιλεγμένος υποψήφιος δεν είναι πλέον διαθέσιμος",
        MESSAGE: 'Ο επιλεγμένος υποψήφιος ({0}) δεν είναι πλέον διαθέσιμος. Επιλέξτε άλλον υποψήφιο',
        CLOSE_LABEL: "OK"
    },
    RESELECT_JOB_FILLER_RESULT_DIALOG: {
        TITLE: "Η ημερομηνία/ώρα κράτησης άλλαξε. Επιλέξτε ξανά υποψήφιο για την κράτηση",
        CLOSE_LABEL: "OK"
    },
    REQUEST_TIMEOFF_APPROVED_RESULT_DIALOG: {
        TITLE: "Το αίτημα εγκρίθηκε"
    },
    REQUEST_TIMEOFF_DECLINED_RESULT_DIALOG: {
        TITLE: "Το αίτημα απορρίφθηκε"
    },
    MARK_SELECTED_TASK_COMPETED_RESULT_DIALOG: {
        TITLE: "Επισημάνθηκαν επιλεγμένες εργασίες ως ολοκληρωμένες"
    },
    SCRAPER_STATUS_RESULT_DIALOG: {
        TITLE: "Αυτό μπορεί να διαρκέσει μερικά λεπτά, συνεχίστε αυτό που κάνετε και ανανεώστε το σε λίγα λεπτά."
    },
    SHIFT_JOB_REPORT_SUBMITTED: {
        TITLE: "{0} αναφορά υποβλήθηκε με επιτυχία"
    },
    MANUAL_TRANSFER_SUCCESS: {
        TITLE: "Η μεταφορά με επιτυχία",
        MESSAGE: "Αναγνωριστικό μεταφοράς: {0}"
    },
    EMAIL_SENT_RESULT_DIALOG: {
        TITLE: "Τα μηνύματα ηλεκτρονικού ταχυδρομείου εστάλησαν"
    },
    MARK_JOB_COMPLETED_RESULT_DIALOG: {
        TITLE: "Η εργασία επισημάνθηκε ως ολοκληρωμένη"
    },
    PACKAGE_CREATED_RESULT_DIALOG: {
        TITLE: "Το πακέτο δημιουργήθηκε."
    },
    PACKAGE_UPDATED_RESULT_DIALOG: {
        TITLE: "Το πακέτο ενημερώθηκε."
    },
    PACKAGE_DELETED_RESULT_DIALOG: {
        TITLE: "Το πακέτο διαγράφηκε."
    },
    TIP_CHARGE_RESULT_DIALOG: {
        TITLE: "Η συμβουλή σας έχει σταλεί στο {0}, σας ευχαριστούμε πολύ!"
    },
    REPORT_PROBLEM_RESULT_DIALOG: {
        TITLE: "Το πρόβλημα αναφέρθηκε με επιτυχία"
    },
    COPY_USER_FIELD_RESULT_DIALOG: {
        TITLE: "Τα πεδία αντιγράφηκαν με επιτυχία",
        MESSAGE: "Τα δεδομένα αντιγράφονται από {0} σε {1}"
    },
    CANCEL_EMAIL_RESULT_DIALOG: {
        TITLE: "Το email ακυρώθηκε"
    },
    REVIEW_DELETED_RESULT_DIALOG: {
        TITLE: "Η κριτική διαγράφηκε."
    },
    NEED_AGENCY_PHONE_RESULT_DIALOG: {
        TITLE: "Δεν έχετε ρυθμίσει ακόμα το SMS!",
        MESSAGE: "Επικοινωνήστε με την ομάδα μας για να ξεκινήσετε."
    },
    ADDITIONAL_DATE_ADDED_RESULT_DIALOG: {
        TITLE: "Προστέθηκαν κρατήσεις"
    },
    INVOICE_SENT_RESULT_DIALOG: {
        TITLE: "Το τιμολόγιο στάλθηκε"
    },
    STRIPE_ACCOUNT_DELETED: {
        TITLE: "Διαγράφηκε ο λογαριασμός Sripe"
    },
    SUBMITTED_MODAL_RESULT_DIALOG: {
        TITLE: "Ευχαριστούμε, θα επικοινωνήσουμε σύντομα!"
    },
    NO_CANDIDATE_AVAILABLE_FOR_ALL_BOOKING: {
        TITLE: "Δεν υπάρχει υποψήφιος που να είναι διαθέσιμος για όλες τις ανοιχτές κρατήσεις"
    },
    RETURNING_APPLICANT_RESULT_DIALOG: {
        TITLE: "Οι πληροφορίες που καταχωρίσατε προηγουμένως έχουν φορτωθεί, συνεχίστε!"
    },
    JOB_SHARE_MARKET_PLACE_RESULT_DIALOG: {
        TITLE: "Η εργασία μοιράζεται με την αγορά του πρακτορείου"
    },
    CANDIDATE_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Ο υποψήφιος υποβάλλεται στη θέση εργασίας"
    },
    BULK_RESOURCE_DELETED_RESULT_DIALOG: {
        TITLE: "{0} {1} διαγράφηκε"
    },
    REPEAT_BLASTER_BEING_SENT_RESULT_DIALOG: {
        TITLE: "{0} αποστέλλονται"
    },
    BOOKING_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Η κράτησή σας υποβλήθηκε, μπορείτε να κλείσετε το παράθυρο"
    },
    FILLED_JOB_RESULT_DIALOG: {
        TITLE: "Αυτή η θέση εργασίας έχει καλυφθεί!"
    }
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/result-dialog/el.js